module.exports = __webpack_public_path__ + "img/5-small.f0e16dec.png";